import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Box,
  Checkbox,
  CircularProgress,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import { memo, useCallback, useState } from "react";
import { FlexCenterWrapper } from "../../../../../../../components/DefaultNoDataWrapper";
import Flex from "../../../../../../../components/Flex";
import SearchInput from "../../../../../../../components/SearchInput";
import Text from "../../../../../../../components/Text";
import { useDebounce } from "../../../../../../../hooks/use-debounce";
import { useDefaultPatientAssessmentList } from "../../../../../../../queries/patient-chart/assessment/use-get-all-default-screening-assessment";
import { DEFAULT_FONTSIZE } from "../../../../../../../utils/utils";
import NewAssessment from "./NewAssessment";
import { ScreeningKeys } from "./constant-ass";
import { ASS_ASSESSMENT } from "./constant-new-ass";

interface ScreeningStartNewLayoutProps {
  onClose: () => void;
}

const ScreeningStartNewLayout = ({ onClose }: ScreeningStartNewLayoutProps) => {
  const [selectedScreening, setSelectedScreening] =
    useState<ScreeningKeys | null>(null);
  const [_checkedItems, setCheckedItems] = useState<Record<string, boolean>>(
    {}
  );
  const { data: assData, isLoading }: any = useDefaultPatientAssessmentList();

  const handleCheckboxChange = (screeningKey: string) => {
    setCheckedItems((prev) => ({
      ...prev,
      [screeningKey]: !prev[screeningKey],
    }));
  };

  const [allAssessments, setAllAssessments] =
    useState<{ value: string; label: string }[]>(ASS_ASSESSMENT);

  const [_search, setSearch, instantSearch] = useDebounce<string>("");

  const handleSearch = useCallback((searchValue: string) => {
    setSearch(searchValue);
    const filteredAssessments = ASS_ASSESSMENT?.filter((assessment) => {
      return assessment?.value
        ?.toLowerCase()
        ?.includes(searchValue?.toLowerCase());
    });

    setAllAssessments(filteredAssessments);
  }, []);

  return (
    <Flex gap={1} width={"100%"} height={"100%"}>
      {/* Left Sidebar */}
      <Box
        width={"24%"}
        sx={{
          borderRight: "1px solid #e0e0e0",
          backgroundColor: "#fafafa",
          height: "100%",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <Box sx={{ borderBottom: "1px solid #e0e0e0" }}>
          <Flex alignItems="center" gap={1}>
            <IconButton
              onClick={() => {
                // setIsNewScreeningView(false);
                onClose();
              }}
            >
              <ArrowBackIcon fontSize="small" />
            </IconButton>
            <Text fontWeight="bold">Choose a Screening</Text>
          </Flex>
          {/* <Text variant="body2" color="text.secondary">
            {`${Object.keys()} of ${Object.keys(assData??{}).length} In the choose a screener section`}
          </Text> */}
          <Typography
            variant="subtitle1"
            sx={{ mt: 1, fontWeight: "medium" }}
            ml={2}
          >
            Choose one screening Assessment.
          </Typography>
          <Box p={1}>
            <SearchInput
              searchKey={instantSearch}
              onSearch={(v: string) => handleSearch(v)}
              placeholder="Search Screening"
            />
          </Box>
        </Box>

        {/* Screening List */}
        <Box sx={{ height: "calc(100% - 160px)", overflow: "auto" }}>
          {allAssessments?.length > 0 ? (
            <List sx={{ p: 0 }}>
              {allAssessments?.map((assessment) => (
                <ListItem key={assessment.value} disablePadding>
                  <ListItemButton
                    onClick={() =>
                      setSelectedScreening(assessment.value as ScreeningKeys)
                    }
                    sx={{
                      bgcolor:
                        selectedScreening === assessment.value
                          ? "primary.light"
                          : "transparent",
                      py: 1.5,
                    }}
                  >
                    <Checkbox
                      checked={selectedScreening === assessment.value}
                      onChange={() => handleCheckboxChange(assessment.value)}
                    />
                    <ListItemText
                      primary={`${assessment.label} (${assessment.value})`}
                      primaryTypographyProps={{
                        fontSize: DEFAULT_FONTSIZE.fontSize,
                        color:
                          selectedScreening === assessment.value
                            ? "primary.main"
                            : "inherit",
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          ) : (
            <FlexCenterWrapper>
              No screenings found matching your search
            </FlexCenterWrapper>
          )}
        </Box>
      </Box>

      {/* Right Content Area */}
      <Box width={"76%"} height={"100%"} sx={{ overflow: "hidden" }}>
        {isLoading && (
          <FlexCenterWrapper>
            <CircularProgress />
          </FlexCenterWrapper>
        )}

        {assData?.data?.assessments && (
          <NewAssessment
            defaultData={assData?.data?.assessments}
            selectedScreening={selectedScreening}
            onClose={onClose}
            // setIsNewScreeningView={setIsNewScreeningView}
          />
        )}
      </Box>
    </Flex>
  );
};

export default memo(ScreeningStartNewLayout);
